import { createFileRoute } from "@tanstack/react-router"
import ActivityDetailPage from "@/app/activity/detail/page"

export const Route = createFileRoute("/activity/detail")({
  component: ActivityDetailPage,
})
